module.exports = __webpack_public_path__ + "static/media/homeMenuInactive.ba09da38.svg";